/**
 * @module views\sys\page
 */
import Vue from "vue";
import Component from "vue-class-component";
import GhBase from "@/components/ghBase";

@Component
export default class Page extends GhBase {
  private argsQuery = { keyword: "" };

  private getPropType(props: IProp[], name: string) {
    if (props && name) {
      return props.find(item => item.value === name);
    }
    return {};
  }

  private submitCode(model) {
    let refs = ["codeService", "codePage"];
    refs.map(item => this.codeEditSubmit(item));
  }

  private codeEditSubmit(ref) {
    let editor = this.$refs[ref] as IndexObject;
    if (editor) {
      editor.submit();
    }
  }
}
